<template>
    <signView :viewType="2">
        <template  v-slot:mainCenter>
            <div class="login_box register_box">
                <div class="login_item">
                    <div class="login_from">
                        <h1 class="centerText bold_primaryText">
                            Sign up your<br />
                            organisation now to<br />
                            unlock the Benyfits
                        </h1>
                        <div class="flex_input">
                            <el-input v-model="firstName" maxlength="20" :class="{'is-error':emptyFname}" @blur="valid(1)" class="myLogin_input" placeholder="First name"></el-input>
                            <el-input v-model="lastName" maxlength="20" :class="{'is-error':emptyLname}" @blur="valid(2)" class="myLogin_input" placeholder="Last name"></el-input>
                        </div>
                        <el-input v-model="companyName" :class="{'is-error':emptyCname}" maxlength="30" @blur="valid(3)" class="myLogin_input marginTB1" placeholder="Your company name"></el-input>
                        <el-input v-model="companyTradingName" :class="{'is-error':emptyCTname}" maxlength="30" @blur="valid(7)" class="myLogin_input" style="margin-bottom:16px;" placeholder="Your company trading name"></el-input>
                        <el-select v-model="industry" placeholder="Industry">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-input v-model="approximateNum" :class="{'is-error':emptyAppNum}" @input="approximateNum=approximateNum.replace(/[^\d]/g,'')" maxlength="10" @blur="valid(6)" class="myLogin_input marginTB2" placeholder="Approximate number of employees"></el-input>
                        <el-input v-model="email" maxlength="100" :class="{'is-error':emptyEmail||!isSuccessFormat}" @blur="valid(4)" class="myLogin_input" placeholder="Email address"></el-input>
                        <transition name="el-fade-in">
                            <p v-show="!isSuccessFormat" class="error_msg">The email format entered is incorrect.</p>
                        </transition>
                        <el-input type="password" maxlength="16" autocomplete="new-password" v-model="password" :class="{'is-error':emptyPassword}" @blur="valid(5)" class="myLogin_input marginTB_input" placeholder="Password"></el-input>
                        <div class="default_Btn" :class="{'loading_btn':loading}" @click="submit">Get started
                            <i v-show="loading" class="el-icon-loading my_loading_icon"></i>
                        </div>
                        <p class="primaryText login_foot centerText">
                            By signing up, you agree to our<br />
                            terms of service and privacy policy.
                        </p>
                    </div>
                    <div class="register_icon"></div>
                </div>
            </div>
        </template>
    </signView>
</template>

<script>
import api from '../../api/login.js'
import signView from '../common/sign-view.vue'
import md5 from 'js-md5'
export default {   
    components:{signView},
    data() {
        return {
            isSuccessFormat:true,
            loading:false,
            emptyFname:false,
            emptyLname:false,
            emptyCTname:false,
            emptyCname:false,
            emptyEmail:false,
            emptyPassword:false,
            emptyAppNum:false,
            approximateNum:'',
            firstName:'',
            lastName:'',
            email:'',
            companyName:'',
            companyTradingName:'',
            password:'',
            invitationId:'',
            industry: '',
            options: [
                {
                    value: 'Agriculture & Mining',
                    label: 'Agriculture & Mining'
                },
                {
                    value: 'Clerical Support',
                    label: 'Clerical Support'
                },
                {
                    value: 'Education & Training',
                    label: 'Education & Training'
                },
                {
                    value: 'Energy',
                    label: 'Energy'
                },
                {
                    value: 'Financial & Insurance Services',
                    label: 'Financial & Insurance Services'
                },
                {
                    value: 'Food & Beverage',
                    label: 'Food & Beverage'
                },
                {
                    value: 'Government & Public Sector',
                    label: 'Government & Public Sector'
                },
                {
                    value: 'Health Care & Social Assistance',
                    label: 'Health Care & Social Assistance'
                },
                {
                    value: 'Hospitality',
                    label: 'Hospitality'
                },
                {
                    value: 'Legal',
                    label: 'Legal'
                },
                {
                    value: 'Manufacturing',
                    label: 'Manufacturing'
                },
                {
                    value: 'Professional Services',
                    label: 'Professional Services'
                },
                {
                    value: 'Property & Construction',
                    label: 'Property & Construction'
                },
                {
                    value: 'Retail',
                    label: 'Retail'
                },
                {
                    value: 'Sport & Recreation',
                    label: 'Sport & Recreation'
                },
                {
                    value: 'IT & Technology',
                    label: 'IT & Technology'
                },
                {
                    value: 'Transport & Logistics',
                    label: 'Transport & Logistics'
                },
                {
                    value: 'Travel & Tourism',
                    label: 'Travel & Tourism'
                },
                {
                    value: 'Other',
                    label: 'Other'
                }
            ]
        }
    },
    methods: {
        valid(key){
            switch (key) {
                case 1:
                    this.emptyFname = this.firstName?false:true
                    break;
                case 2:
                    this.emptyLname = this.lastName?false:true
                    break;
                case 3:
                    this.emptyCname = this.companyName?false:true
                    break;
                case 4:
                    this.emptyEmail = this.email?false:true
                     if(!this.emptyEmail){
                        this.emptyEmail = false
                        this.isSuccessFormat = Utils.isEmail(this.email)
                        if (this.isSuccessFormat) {
                            if (this.email.indexOf('@sb.com') !== -1 || this.email.indexOf('@sb.co') !== -1 ||
                            this.email.indexOf('@shabi.com') !== -1 || this.email.indexOf('@shabi.co') !== -1) {
                                this.isSuccessFormat = false
                            }
                        }
                    }
                    break;
                case 5:
                    this.emptyPassword = this.password?false:true
                    break;
                case 6:
                    this.emptyAppNum = this.approximateNum?false:true
                    break;
                case 7:
                    this.emptyCTname = this.companyTradingName?false:true
                    break;
            }
        },
        submit(){
            if(this.loading) return
            for (let index = 0; index <= 6; index++) {
                this.valid(index)
            }
            if(!this.approximateNum||this.approximateNum=='0'){
                Utils.alert('','The number of employees cannot be 0','error')
                return
            }
            if(this.emptyFname||this.emptyLname||this.emptyCname||this.emptyEmail||this.emptyPassword||!this.isSuccessFormat) return
            if(this.password.split('').length<8||this.password.split('').length>16){
                Utils.alert('','Please enter a password of 8-16 digits','error')
                return
            }
            const pat = {
                "companyEmail":this.email,
                "companyName":this.companyName,
                "companyTradingName":this.companyTradingName,
                "firstName":this.firstName,
                "lastName":this.lastName,
                approximateNumberOfEmployees:this.approximateNum,
                "password":md5(this.password),
                invitationId:this.invitationId,
                industry: this.industry
            }
            this.loading = true
            api.register(pat,res=>{
                const {code,message} = res.data;
                this.loading = false
                if(code == 200){
                    // this.$router.push('/login')
                    Utils.alert('',message,'success')
                    const token = res.headers['benycompany-satoken']
                    console.log(token);
                    window.localStorage.setItem('TOKEN_KEY',token)
                    var obj = document.createElement('a');
                    obj.href = `https://web.beny.com.au/#/oa/home?beny=${token}`;
                    obj.click();
                } else if(code == 30000){
                    Utils.alert('','Email has been registered','error')
                }else{
                    Utils.alert('',message,'error')
                }
            })
        }
    },
    mounted() {
        const query = this.$route.query;
        this.email = !query.email?'':query.email
        this.invitationId = !query.invitationId?'':query.invitationId
    },
}
</script>

<style lang="scss" scoped>
.login_box{
    min-height: calc(100vh - 128px);
    padding-top: 106px;
    padding-bottom: 40px;
    // overflow: hidden;
    .login_item{
        display: flex;
        width: 1220px;
        margin: 0 auto;
        .login_from{
            width: 580px;
            min-width: 580px;
            .flex_input{
                display: flex;
                .myLogin_input{
                    &:last-child{
                        margin-left: 16px;
                    }
                }
            }
            .marginTB{
                opacity: 1;
                margin: 20px 0 30px 0;
            }
            .marginTB1{
                margin: 16px 0;
            }
            .marginTB2{
                margin:0 0 16px 0;
            }
            .marginTB_input{
                margin: 16px 0 24px 0;
            }
            .new_top{
                font-size: 17px;
                font-family: Lora-Regular, Lora;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 21px;
            }
            .login_foot{
                font-size: 15px;
                opacity: 0.8;
                margin-top: 24px;
                line-height: 18px;
            }
            /deep/{
                .myLogin_input{
                    height: 55px;
                    .el-input__inner{
                        height: 55px;
                        line-height: 55px;
                        background: #4e4c4a;
                        border-color: #4e4c4a;
                        color: #FFFFFF;
                    }
                }
            }
            h1{
                margin-bottom: 48px;
            }
        }
        .register_icon{
            margin-left: auto;
            width: 570px;
            min-width: 570px;
            height: 567px;
            // background: #ccc;
            background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/bba6b784a39c4b2c81fb8c51bb8cc0cf.png') no-repeat;
            background-size: contain;
            margin-top: 118px;
            position: relative;
        }
    }
}
.register_box{
    padding-top: 76px;
}
</style>


// WEBPACK FOOTER //
// src/components/sign/registered.vue